import { IJsonSerializable, IOpChangeState, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpDescr } from './op-descr'

export class OpPaymentModuleType implements IOpChangeState, IJsonSerializable {

    // #region Properties

    public idPaymentModuleType: number
    public name: string
    public idDescr: number

    // #endregion


    // #region Navigation Properties

    public descr: OpDescr

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // #endregion


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IJsonSerializable implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idPaymentModuleType = opObj.ID_PAYMENT_MODULE_TYPE
            this.idDescr = opObj.ID_DESCR
            this.name = opObj.NAME
            this.descr = opObj._Descr != null ? new OpDescr(opObj._Descr) : null
            this.opState = opObj.OpState
        } else {
            this.idPaymentModuleType = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_PAYMENT_MODULE_TYPE: this.idPaymentModuleType,
            ID_DESCR: this.idDescr,
            NAME: this.name,
            OpState: this.opState
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpPaymentModuleType {
        const paymentModuleType: OpPaymentModuleType = new OpPaymentModuleType()

        paymentModuleType.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return paymentModuleType
    }

    public copy(source: OpPaymentModuleType, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.descr = source.descr // zaimplementować ICopyable
            
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idPaymentModuleType = source.idPaymentModuleType
        this.name = source.name
        this.idDescr = source.idDescr

        this.opState = source.opState
    }

    // #endregion 

}

